import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ForumModerationPage from "@/pages/admin/ForumModerationPage";

export const Route = createFileRoute("/_admin/admin/forum-moderation")({
  head: () => pageHead("Admin · Forum Moderation", "AKIVA admin · forum moderation portal.", "/admin/forum-moderation", true),
  component: ForumModerationPage,
});
